var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClear = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20381_3726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 -0.000488281C12.9179 -0.000488281 16.5 3.58263 16.5 8.00049C16.4997 12.4181 12.9177 16.0005 8.5 16.0005C4.08231 16.0005 0.500264 12.4181 0.5 8.00049C0.5 3.58263 4.08214 -0.000488088 8.5 -0.000488281ZM8.5 1.35693C4.83214 1.35693 1.85742 4.33263 1.85742 8.00049C1.85769 11.6681 4.83231 14.6431 8.5 14.6431C12.1677 14.6431 15.1423 11.6681 15.1426 8.00049C15.1426 4.33263 12.1679 1.35693 8.5 1.35693ZM11.4541 5.03174C11.5325 5.03199 11.5967 5.09687 11.5967 5.17529C11.5966 5.2091 11.5858 5.24316 11.5645 5.26807L9.24121 8.03564L11.5605 10.8013C11.582 10.8281 11.5947 10.8611 11.5947 10.895C11.5945 10.9751 11.5304 11.0374 11.4521 11.0376L10.2734 11.0317L8.5 8.91748L6.72656 11.0337L5.54688 11.0396C5.4683 11.0396 5.40332 10.9746 5.40332 10.896C5.40378 10.8622 5.416 10.8293 5.4375 10.8032L7.76074 8.0376L5.4375 5.27002C5.41607 5.24323 5.40332 5.2102 5.40332 5.17627C5.40355 5.09612 5.46845 5.03369 5.54688 5.03369L6.72656 5.03955L8.5 7.15381L10.2754 5.0376L11.4541 5.03174Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20381_3726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClear, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clear.eeffd83f.svg";
export { ForwardRef as ReactComponent };